import './App.css'
import { Route, BrowserRouter as Router, Routes } from "react-router-dom"
import Login from './pages/login'
import Home from './pages/homepage'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import EditUserPhoto from './pages/edit-up'
import Users from './pages/users'
import Install from './pages/install'
import { GlobalProvider, useGlobal } from './context/global'
import UserAgent from './pages/test/user-agent'
import SignUp from './pages/signup'
import Applicants from './pages/applicants'
import { VolunteerProvider } from './context/volunteer'
import Volunteers from './pages/volunteers'
import Sevas from './pages/admin/sevas'
import Admin from './pages/admin'
import SevaDates from './pages/admin/sevadates'
import Register from './pages/register'
import Protect from './protect'
import { useEffect } from 'react'
import { requestNotificationPermission } from './firebase/messaging'
import Chrome from "./pages/chrome"
import MaintenancePage from './pages/maintenance'

function AppContent({ initData }) {
  const { auth, deviceInfo, apiClient } = initData
  const { os, browser, isMobileDevice, appInstalled } = deviceInfo
  const { maintenance, toggleMaintenance } = useGlobal()

  const isAppAdmin = auth && auth.users && auth.users.some(u => u.roleID === 'app-admin')
  const isUnderMaintenance = maintenance.active && !isAppAdmin

  useEffect(() => {
    requestNotificationPermission().then(fcmToken => {
      if (!auth) {
        return
      }

      if (fcmToken) {
        const payload = auth.users.map(user => {
          return {
            userID: user.id,
            fcmToken, os, browser, isMobileDevice, appInstalled
          }
        })

        apiClient.call('/update-device', payload).catch(err => {
          console.log(err)
        })
      }
    }).catch(err => {
      console.log(err)
    })
  }, [])

  if (isUnderMaintenance) {
    return <MaintenancePage />
  }

  const handleDeactivateMaintenance = () => {
    if (window.confirm("Are you sure you want to deactivate Maintenance Mode and restore website access to all users?")) {
      toggleMaintenance(false)
        .then(() => toast.success("Maintenance mode has been deactivated. Website is now accessible to everyone."))
        .catch(err => toast.error(err.message || "Failed to deactivate maintenance mode"))
    }
  }

  return (
    <>
      {isAppAdmin && maintenance.active && (
        <div className="maintenance-admin-banner">
          <div className="maintenance-admin-banner-text">
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            <span>MAINTENANCE MODE IS ACTIVE — Website is hidden from all users. Only you (App Admin) have access.</span>
          </div>
          <button
            type="button"
            className="maintenance-banner-deactivate-btn"
            onClick={handleDeactivateMaintenance}
          >
            Deactivate
          </button>
        </div>
      )}

      <Router>
        <Routes>
          <Route path="/" exact element={<Login />}></Route>
          <Route path="/login" exact element={<Home />}></Route>
          <Route path="/edit-up" exact element={<EditUserPhoto />}></Route>
          <Route path="/home" exact element={<Home />}></Route>

          <Route path="/users" exact
            element={<Protect role={0}><Users /></Protect>}>
          </Route>

          <Route path="/signup" exact element={!initData.deviceInfo.isChrome ? <Chrome /> : <SignUp />}></Route>

          <Route path="/applicants" exact
            element={
              <Protect role={3}>
                <VolunteerProvider>
                  <Applicants />
                </VolunteerProvider>
              </Protect>}>
          </Route>

          <Route path="/volunteers" exact
            element={
              <Protect role={3}>
                <VolunteerProvider>
                  <Volunteers />
                </VolunteerProvider>
              </Protect>}>
          </Route>

          <Route path="/install" exact element={<Install />}></Route>

          <Route path="/admin/seva" exact element={<Protect role={0}><Sevas /></Protect>}></Route>
          <Route path="/admin/seva-dates" exact element={<Protect role={0}><SevaDates /></Protect>}></Route>

          <Route path="/register/:seva" exact element={<Register />}></Route>
          <Route path="/register" exact element={<Register />}></Route>

          <Route path="/test/user-agent" exact element={<UserAgent />}></Route>
          <Route path="/admin" exact element={<Admin />}></Route>
        </Routes>
      </Router>
    </>
  )
}

function App({ initData }) {
  return (
    <div className="App">
      <GlobalProvider initData={initData}>
        <AppContent initData={initData} />
      </GlobalProvider>
      <ToastContainer />
    </div>
  )
}

export default App
